import Input from "@/types/Input.interface"
import Template, { TemplateType } from "@/types/Template.interface"

export default {
    computed: {
        hasInvoices(): boolean {
            return this.$store.getters.hasInvoices
        }
    },
    methods: {
        newTemplate(): Template {
            //  Get the authenticated user
            const user = this.$store.getters.user

            //  If the user does NOT exist, throw error
            if (!user) throw 'A user is required to create a new message template'

            //  Create a new message template (with user as the author)
            const template = {
                author_id: user.id,
                template_name: '',
                message_body: '',
                default: 0,
                type: TemplateType.message,
                media_id: null
            }

            //  Return the new template
            return template
        },
        popNewTemplate(): void {
            //  Create a new template model
            const template = this.newTemplate()

            //  Get our filtered template inputs
            const inputs = this.templateInputs(template)

            //  Pop an app-form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'New Message Template',
                icon: 'mdi-format-size',
                color: 'primary',
                closeable: true,
                component: 'app-form',
                props: {
                    color: 'primary',
                    model: template,
                    inputs: inputs
                },
                callback: (template: Template): void => this.templatePost(template),
            })
        },
        templateInputs(template: Template): Input[] {
            //  Grab our template inputs
            const inputs = this.$store.getters.templateInputs(template)

            //  Check if we are a QBO or Xero data provider
            const provider = this.$store.getters.tenant.data_provider
            const payments = provider === 'XERO' || provider === 'QBO'

            //  Check if we are in the templates module
            const isTemplates = this.$route.path.includes('templates')

            //  If we have payments enabled AND we are NOT in the templates mod, remove our type selector
            if (payments && !isTemplates) {
                //  Remove the first input
                inputs.shift()
            }

            //  Return our inputs
            return inputs
        },
        async templatePost(template: Template): Promise<void> {
            //  If the template does NOT exist, do nothing
            if (!template) return

            //  If this template does NOT have a type, default to 'message'
            if (!template.type) template.type = TemplateType.message

            //  Else, post the template with the API
            const response = await this.$store.dispatch('templatesPost', template)

            //  If the request failed, do nothing
            if (!response) return

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', {
                message: 'Template Updated',
                type: 'success'
            })
        }
    }
}